// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pic[data-v-65dfbb99]{width:30%;margin:20px}.scroll[data-v-65dfbb99]{overflow:auto}.app-container[data-v-65dfbb99]{height:100%}.header[data-v-65dfbb99]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-tag+.el-tag[data-v-65dfbb99]{margin-left:10px}", ""]);
// Exports
module.exports = exports;
